export const OrderDetailsPageTemplate = {
    slots: ['SlbCheckoutContainerSlot'],
};